import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useUnderwritingForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Borrowers',
        fields: [
          {
            title: 'Borrower credit',
            name: 'borrower_credit',
            type: 'number',
          },
          {
            title: 'Borrower - Self-employed',
            name: 'borrower_self_employed',
            type: 'checkbox',
          },
          {
            title: 'Coborrower credit',
            name: 'coborrower_credit',
            type: 'number',
          },
          {
            title: 'Coborrower - Self-employed',
            name: 'coborrower_self_employed',
            type: 'checkbox',
          },
        ],
      },
      {
        title: 'Debt-to-income',
        fields: [
          {
            title: 'DTI front end',
            name: 'dti_front',
            type: 'percentage',
            limitDecimals: 2,
          },
          {
            title: 'DTI back end',
            name: 'dti_back',
            type: 'percentage',
            limitDecimals: 2,
          },
        ],
      },
      {
        title: 'Loan',
        fields: [
          {
            title: 'Down payment',
            name: 'down_payment',
            type: 'currency',
          },
          {
            title: 'LTV at closing',
            name: 'ltv_original',
            type: 'percentage',
            limitDecimals: 2,
          },
          {
            title: 'Purchase price',
            name: 'purchase_price',
            type: 'currency',
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useUnderwritingForm;
